import React from 'react';

const HomePage = () => {
  return (
    <div 
      id="home" 
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#36A6C9] to-[#365DC9] text-white"
    >
      <div className="text-center max-w-3xl px-4">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Transforming Wearable Technology
        </h1>
        <p className="text-xl mb-8 text-white/90">
          Veltrah is developing cutting-edge software and the future of wearable technology.
        </p>
        <div className="flex justify-center space-x-4">
          <a 
            href="#services" 
            className="bg-[#FD6101] text-white px-6 py-3 rounded-full hover:bg-opacity-90 transition duration-300"
          >
            Our Products
          </a>

        <a 
            href="mailto:info@veltrah.com?subject=Inquiry&body=Hello, I would like to learn more about your products." 
            className="bg-[#FD6101] text-white px-4 py-2 rounded-full hover:bg-opacity-90"
            >
        Contact Us
        </a>
        </div>
        
            {/* Third Bubble */}
            <div className="flex justify-center mt-4">
                <div 
                    className="bg-[#F0F0F0] text-[#333] px-6 py-3 rounded-full border border-[#CCC] text-center cursor-pointer hover:bg-[#E0E0E0] hover:text-[#000] transition duration-300"
                >
                    Email: <strong>info@veltrah.com </strong>
                </div>
            </div>
      </div>
      
    </div>
  );
};

export default HomePage;